export default __webpack_public_path__ + "static/media/loot-box.4a94dd80.png";